/**
 * Static application IDs, these do not include the applicationIds for applications such as One for Teams or the One Admin portal since these have different applications per environment.
 */
export enum ApplicationIds {
	OneForYou = "14cbb697-6370-4abf-ac6a-0d03c49ef3aa",
	OneQualityManagement = "4e0821d3-3689-4a90-a584-e83078245739",
	OneForMedia = "85eb2f4a-f445-4357-a03e-80bbf78b1d3d",
}
